(() => {
  const storefrontRoots = ['/collections', '/products', '/pages', '/policies', '/search', '/cart', '/blogs', '/account'];
  const staleMarketPrefixes = ['/en-sa', '/ar-sa'];
  const languagePrefixes = ['/en', '/ar'];

  const normalizeStaleMarketPath = () => {
    const { pathname, search, hash } = window.location;
    for (const prefix of staleMarketPrefixes) {
      if (pathname === prefix || pathname === `${prefix}/` || pathname.startsWith(`${prefix}/`)) {
        const isArabic = prefix === '/ar-sa';
        const remainder = pathname.slice(prefix.length) || '/';
        const normalizedRemainder = remainder.startsWith('/') ? remainder : `/${remainder}`;
        const targetPath = isArabic
          ? (normalizedRemainder === '/' ? '/ar/' : `/ar${normalizedRemainder}`)
          : normalizedRemainder;
        window.location.replace(`${targetPath}${search}${hash}`);
        return true;
      }
    }
    return false;
  };

  if (normalizeStaleMarketPath()) return;

  const currentRoot = () => {
    const root = document.body?.dataset?.rootUrl || window.Shopify?.routes?.root || '/';
    if (root === '/') return '/';
    return `/${root.replace(/^\/+|\/+$/g, '')}/`;
  };

  const stripLanguagePrefix = (pathname) => {
    for (const prefix of languagePrefixes) {
      if (pathname === prefix || pathname === `${prefix}/`) return '/';
      if (pathname.startsWith(`${prefix}/`)) return pathname.slice(prefix.length);
    }
    return pathname;
  };

  const localizeHref = (href) => {
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:') || href.startsWith('//')) return href;

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch {
      return href;
    }

    if (url.origin !== window.location.origin) return href;

    const pathname = stripLanguagePrefix(url.pathname);
    const isStorefrontPath = pathname === '/' || storefrontRoots.some((root) => pathname === root || pathname.startsWith(`${root}/`));
    if (!isStorefrontPath) return href;

    const root = currentRoot();
    let localizedPath = pathname;
    if (root !== '/') {
      const prefix = root.replace(/\/$/, '');
      localizedPath = pathname === '/' ? root : `${prefix}${pathname}`;
    }

    return `${localizedPath}${url.search}${url.hash}`;
  };

  const updateAnchor = (anchor) => {
    const href = anchor.getAttribute('href');
    const localizedHref = localizeHref(href);
    if (localizedHref && localizedHref !== href) anchor.setAttribute('href', localizedHref);
  };

  const updateLinks = (root) => {
    if (root.nodeType === 1 && root.matches && root.matches('a[href]')) updateAnchor(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(updateAnchor);
  };

  const start = () => {
    updateLinks(document);

    document.addEventListener('click', (event) => {
      const anchor = event.target.closest && event.target.closest('a[href]');
      if (anchor) updateAnchor(anchor);
    }, true);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          updateAnchor(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(updateLinks);
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  };

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
